import axios from "axios"
import baseUrl from "./../base"

const pelaporanApi = {
  storeFormPelaporan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/master/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showFormPelaporan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/formPelaporanPenduduk/master/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeJenisFormPelaporan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/jenisFormPelaporan/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/master/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanKelahiran: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/kelahiran/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanKelahiran: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/kelahiran/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanDataOrangTua: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/dataOrangtua/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanDataOrangTua: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/dataOrangtua/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPelapor: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/pelapor/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanPelapor: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/pelapor/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanSaksi: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/saksi/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanSaksi: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/saksi/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanLahirMati: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/lahirMati/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanLahirMati: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/lahirMati/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanKematian: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/kematian/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanKematian: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/kematian/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPerkawinan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/perkawinan/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPerceraian: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/perceraian/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateFormPelaporanPerkawinan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/perkawinan/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanCapilLuarNkri: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/capilLuarNkri/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanSubjekAktaKesatu: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/subjekAktaKesatu/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanSubjekAktaKedua: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/subjekAktaKedua/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPembetulanPembatalanAkta: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/pembetulanPembatalanAkta/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPengakuanAnak: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/pengakuanAnak/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPengangkatanAnak: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/pengangkatanAnak/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPengesahanAnak: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/pengesahanAnak/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPeristiwaPenting: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/peristiwaPenting/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPerubahanNama: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/perubahanNama/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeFormPelaporanPerubahanStatusKewarganegaraan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/formPelaporanPenduduk/perubahanStatusKewarganegaraan/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  cetakFormPelaporan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/formPelaporanPenduduk/master/${id}/cetak`,
      { headers: { Authorization: `Bearer ${token}` }, responseType: 'arraybuffer' }
    )
  }
}

export default pelaporanApi